var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgD3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    width: 172,
    height: 217.75,
    viewBox: "0 0 172 217.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30",
    "data-name": "Group 30",
    transform: "translate(-790.5 -2007.75)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_98_",
    "data-name": "98%",
    transform: "translate(876.5 2126.75)",
    fill: "#308275",
    fontSize: 100,
    fontFamily: "Oswald-Bold, Oswald",
    fontWeight: 700,
    letterSpacing: "-0.04em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -85.55,
    y: 0
  }, "98"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "Oswald-Light, Oswald",
    fontWeight: 300
  }, "%")), /*#__PURE__*/React.createElement("text", {
    id: "of_abusers_use_technology_to",
    "data-name": "of abusers use technology to",
    transform: "translate(876.5 2156.5)",
    fill: "#1d1d1d",
    fontSize: 20,
    fontFamily: "Oswald-Medium, Oswald",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -65.7,
    y: 0
  }, "OF ABUSERS USE"), /*#__PURE__*/React.createElement("tspan", {
    x: -63.32,
    y: 22
  }, "TECHNOLOGY TO")), /*#__PURE__*/React.createElement("text", {
    id: "intimidate_or_threaten_their_targets",
    "data-name": "intimidate or threaten their targets",
    transform: "translate(876.5 2202.5)",
    fill: "#1d1d1d",
    fontSize: 16,
    fontFamily: "Lato-Regular, Lato"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -76.372,
    y: 0
  }, "intimidate or threaten"), /*#__PURE__*/React.createElement("tspan", {
    x: -42.556,
    y: 20
  }, "their targets")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgD3);
export default __webpack_public_path__ + "static/media/d3.6173a458a58fec111df0a424619ee7f3.svg";
export { ForwardRef as ReactComponent };